import React, { useState } from 'react';
import { ethers } from "ethers";

let userAddress = "";
let amountCRTavailable = 0;
let accountInfoCR = {};

var truncate = function (fullStr, strLen, separator) {
  if (fullStr.length <= strLen) return fullStr;
  
  separator = separator || '...';
  
  var sepLen = separator.length,
      charsToShow = strLen - sepLen,
      frontChars = Math.ceil(charsToShow/2),
      backChars = Math.floor(charsToShow/2);
  
  return fullStr.substr(0, frontChars) + 
        separator + 
        fullStr.substr(fullStr.length - backChars);
};

let showLoading = false;
var spinner = "◢◣◤◥";
var refreshIntervalId;
var el = document.getElementById("txt-amountCR");
function loadingAnimation(spinner, el, showLoading) {
  var i = 0;
  if (showLoading) {
    refreshIntervalId = setInterval(function() {
      document.getElementById("btn-CRlogin").innerHTML = "Connecting " + spinner[i];
      document.getElementById("txt-amountCR").innerHTML = spinner[i];
      document.getElementById("txt-amountZombieCR").innerHTML = spinner[i];
      document.getElementById("txt-amountAlienCR").innerHTML = spinner[i];
      document.getElementById("txt-collectedCRT").innerHTML = spinner[i];
      document.getElementById("txt-holderDaysCR").innerHTML = spinner[i];
      document.getElementById("txt-startDate").innerHTML = spinner[i];
      document.getElementById("txt-availableCRT").innerHTML = spinner[i];
      document.getElementById("txt-transferedCRT").innerHTML = spinner[i];
      i = (i + 1) % spinner.length;
    }, 300);
  } else {
    clearInterval(refreshIntervalId);
  }
};

function sleep(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

function App() {
  const [user, setUser] = useState();
  const [loggedIn, setLoggedIn] = useState(0);
  const [claimStatus, setClaimStatus] = useState(0);
  const [claimButtonText, setClaimButtonText] = useState("Claim");
  // const [claimStatus, setClaimStatus] = useState();
  // const [claimButtonText, setClaimButtonText] = useState("Coming soon");
  const [detailStatus, setDetailStatus] = useState(0);
  const [detailLinkText, setDetailLinkText] = useState("Show details");
 

  async function CRlogin() {

    if (loggedIn === 0) {
      //console.log(loggedIn);
      try {
        document.getElementById("btn-CRlogin").innerHTML = "Connecting ";
        setLoggedIn(2);
        //document.getElementById("btn-CRlogin").onclick = "javascript: void(0)";
        document.getElementById("btn-CRlogin").onclick = undefined;

        /////////// sign web3 
        const provider = new ethers.providers.Web3Provider(window.ethereum);
        const acc = await provider.send("eth_requestAccounts", []);
        //const sign = provider.getSigner(acc[0]);
        //setUser(await provider.getSigner(acc[0]));
        const user = provider.getSigner(acc[0]);
        const signature = await user.signMessage("Nounscriptions Dashboard");
        // console.log(user);
        // console.log(signature);
        userAddress = acc[0];
        // console.log(userAddress);

        const params =  { userAddress: userAddress };
        showLoading = true;
        loadingAnimation(spinner, el, showLoading);
        //await sleep(2000);

        await fetch('https://crapi-nm13.onrender.com/getaccountinfoNS?address=' + userAddress)
        //await fetch('http://localhost:3000/getaccountinfoNS?address=' + userAddress)
          .then((response) => response.json())
          .then((data) => {
            // console.log(data);
            accountInfoCR = data;
          })
        .catch((err) => {
           // console.log(err.message);
        });
        
        
        amountCRTavailable = accountInfoCR.amountCRTtotal - accountInfoCR.amountCRTtransfered;
        //amountCRTavailable = 30;
        showLoading = false;
        loadingAnimation(spinner, el, showLoading);

        document.getElementById("txt-amountCR").innerHTML = accountInfoCR.amountCR;
        document.getElementById("txt-amountZombieCR").innerHTML = accountInfoCR.amountZombieCR;
        document.getElementById("txt-amountAlienCR").innerHTML = accountInfoCR.amountAlienCR;
        document.getElementById("txt-collectedCRT").innerHTML = accountInfoCR.amountCRTtotal;
        document.getElementById("txt-holderDaysCR").innerHTML = accountInfoCR.holderDaysCR;
        document.getElementById("txt-startDate").innerHTML = accountInfoCR.startDate;
        document.getElementById("link-showCRTable").innerHTML = "More details";
        document.getElementById("txt-availableCRT").innerHTML = accountInfoCR.amountCRTtotal - accountInfoCR.amountCRTtransfered;
        document.getElementById("txt-transferedCRT").innerHTML = accountInfoCR.amountCRTtransfered; 

        document.getElementById("txt-addToMetamask").style.display = "block";

        if (amountCRTavailable >= 1 && accountInfoCR.lastCRTtransferOK) {
          document.getElementById("form-claim").style.display = "block";
          document.getElementById("btn-CRTclaim").value = "Claim";
          document.getElementById("btn-CRTclaim").style = "border-radius:10px;background-color:#2181e2";
          // document.getElementById("btn-CRTclaim").onclick = CRTclaim;
        } else {
          if (amountCRTavailable < 1) {
            document.getElementById("txt-notEnough").style = "background-color:#ffe2e2; display:block";
            document.getElementById("txt-notEnough").innerHTML = "Not have enough $CRT availale to transfer.";
          } else {
            document.getElementById("txt-notEnough").style = "background-color:#ffe2e2; display:block";
            document.getElementById("txt-notEnough").innerHTML = "You already made a claim in the last 24 hours.";
          }
        }


        document.getElementById("btn-CRlogin").innerHTML = "Connected: " + truncate(userAddress, 12);
        //document.getElementById('btn-CRlogin').id = 'btn-CRlogout';
        //document.getElementById("btn-CRlogout").onclick = CRlogout;
        //document.getElementById("btn-CRlogin").onclick = CRlogout;
        setLoggedIn(1);
        // console.log(accountInfoCR);

      } catch (err) {
        console.error(err);
      }
    }

    // console.log(accountInfoCR);

  }

  async function CRlogout() {
    document.getElementById("btn-CRlogin").innerHTML = "Connect wallet";
    document.getElementById("btn-CRlogin").onclick = CRlogin;
    document.getElementById("txt-amountCR").innerHTML = "&#8212;";
    document.getElementById("txt-amountZombieCR").innerHTML = "&#8212;";
    document.getElementById("txt-amountAlienCR").innerHTML = "&#8212;";
    document.getElementById("txt-collectedCRT").innerHTML = "&#8212;";
    document.getElementById("txt-holderDaysCR").innerHTML = "&#8212;";
    document.getElementById("txt-startDate").innerHTML = "&#8212;";

    if (document.getElementById("link-showCRTable")  == null){
      document.getElementById("table-detailsCR").innerHTML = "";
      //document.getElementById('link-hideCRTable').id = 'link-showCRTable';
      document.getElementById("link-showCRTable").innerHTML = "";
      document.getElementById("link-showCRTable").onclick = showCRdetails;
    } else {
      document.getElementById("link-showCRTable").innerHTML = "";
    }
    document.getElementById("txt-availableCRT").innerHTML = "&#8212;";
    document.getElementById("txt-transferedCRT").innerHTML = "&#8212;";

    document.getElementById("form-claim").style.display = "none";
    document.getElementById("txt-notEnough").innerHTML = "";
    document.getElementById("txt-notEnough").style = "background-color:#ffe2e2; display:none";
  
    document.getElementById("txt-addToMetamask").style.display = "none";
  
    if (document.getElementById("link-showCRTtransferTable")  == null){
      document.getElementById("table-detailsCR").innerHTML = "";
      //document.getElementById('link-hideCRTable').id = 'link-showCRTtransferTable';
      document.getElementById("link-showCRTtransferTable").innerHTML = "";
      document.getElementById("link-showCRTtransferTable").onclick = showCRdetails;
    } else {
      document.getElementById("link-showCRTtransferTable").innerHTML = "";
    }
    setLoggedIn(0);
    console.log("logged out");
  }

  async function CRTclaim() {
  // let user = Moralis.User.current();
  if (loggedIn === 1) {
    try {
      setClaimStatus(1);
      setClaimButtonText("Claiming ... please wait !");
      //document.getElementById("btn-CRTclaim").value = "Claiming ... please wait !";
      //document.getElementById("btn-CRTclaim").onclick = "javascript: void(0)";
      // console.log("claimStatus " + claimStatus);
      // console.log("userAddress" + userAddress);
      // console.log("amountCRTavailable" + amountCRTavailable);
      //const params =  { userAddress: userAddress, amountCRTavailable: amountCRTavailable };
      //await sleep(1000);
      //document.getElementById("btn-CRTclaim").value = "Claiming ... please wait !";
      await sleep(2000);
      //const claimInfo = await claimCRT(); //// RMW change to API call

      await fetch('https://crapi-nm13.onrender.com/claimCRT?address=' + userAddress + "&" + "amountCRTavailable=" + amountCRTavailable + "&" + "hashCR=" + accountInfoCR.hashCR  + "&" + "source=" + "ns")
      .then((response) => response.json())
        .then((data) => {
          //console.log(data);
          const claimInfo = data;
      })
      // .catch((err) => {
      //   console.log(err.message);
      // });
      
      
      setClaimStatus(2);
      setClaimButtonText("Claimed successfully !");
      //document.getElementById("btn-CRTclaim").value = "Claimed successfully !";
      document.getElementById("btn-CRTclaim").style="border-radius:10px;background-color:#d1e4dd;color:green;"
      //document.getElementById("btn-CRTclaim").onclick = "javascript: void(0)";
      if (amountCRTavailable < 500){
        document.getElementById("txt-availableCRT").innerHTML = 0;
        document.getElementById("txt-transferedCRT").innerHTML = accountInfoCR.amountCRTtransfered + amountCRTavailable; 
      } else {
        document.getElementById("txt-availableCRT").innerHTML = amountCRTavailable - 500;
        document.getElementById("txt-transferedCRT").innerHTML = accountInfoCR.amountCRTtransfered + 500; 
      }

   } catch(error) {
      setClaimStatus(3);
      setClaimButtonText("Error occured - please try again.");
      //document.getElementById("btn-CRTclaim").value = "Error occured - please try again.";
      document.getElementById("btn-CRTclaim").style="border-radius:10px;background-color:#ffe2e2;color:red;";
      //document.getElementById("btn-CRTclaim").onclick = "javascript: void(0)";
      console.log(error)
   } 

  }
  }

  async function showCRdetails() {

    document.getElementById("link-showCRTable").innerHTML = "Hide details"
    //document.getElementById('link-showCRTable').id = 'link-hideCRTable';
    //document.getElementById("link-hideCRTable").onclick = hideCRdetails;
    var table = document.createElement("table");
    table.style = "border-collapse: collapse; width: 100%";

    var tbody = document.createElement("tbody");

    var tr = document.createElement('tr');
    tr.style = "border-bottom: 1px solid #ddd";

    var td0 = document.createElement('td');
    td0.style = "border: none";
    var boldtext = document.createElement('strong');
    boldtext.appendChild(document.createTextNode("Nounscriptions"));
    td0.appendChild(boldtext);

    var td1 = document.createElement('td');
    td1.style = "border: none";
    td1.appendChild(document.createTextNode(""));
    
    var td2 = document.createElement('td');
    td2.style = "border: none";
    var boldtext2 = document.createElement('strong');
    boldtext2.appendChild(document.createTextNode("Holding"));
    td2.appendChild(boldtext2);

    var td3 = document.createElement('td');
    td3.style = "border: none";
    var boldtext3 = document.createElement('strong');
    boldtext3.appendChild(document.createTextNode("Level"));
    td3.appendChild(boldtext3);

    var td4 = document.createElement('td');
    td4.style = "border: none";
    td4.appendChild(document.createTextNode(""));
    
    tr.appendChild(td0); 
    tr.appendChild(td1);
    tr.appendChild(td2);
    tr.appendChild(td3);
    tr.appendChild(td4);
    tbody.appendChild(tr);

    for (var e = 0; e < accountInfoCR.detailsTableCR.length; e++) {
      var tr = document.createElement('tr');
      tr.style = "border-bottom: 1px solid #ddd";

      var td0 = document.createElement('td');
      td0.style = "border: none";
      var image = document.createElement('img'); 
      image.loading = "lazy"; 
      image.width = "96";
      image.height = "96";
      image.src = accountInfoCR.detailsTableCR[e].image3;
      td0.appendChild(image);
      
      var td1 = document.createElement('td');
      td1.style = "border: none";
      td1.appendChild(document.createTextNode("Genesis #" + accountInfoCR.detailsTableCR[e].CRid));
      
      var td2 = document.createElement('td');
      td2.style = "border: none";
      td2.appendChild(document.createTextNode(accountInfoCR.detailsTableCR[e].holderDays + " days"));
      
      var td2 = document.createElement('td');
      td2.style = "border: none";
      td2.appendChild(document.createTextNode(accountInfoCR.detailsTableCR[e].holderDays + " days"));

      var td3 = document.createElement('td');
      td3.style = "border: none";
      td3.appendChild(document.createTextNode(accountInfoCR.detailsTableCR[e].holderCRLevel));

      var td4 = document.createElement('td');
      td4.style = "border: none";
      var boldtext4 = document.createElement('strong');
      if (accountInfoCR.detailsTableCR[e].holderCRLevel === "Standard") {boldtext4.style = "color:#f5f5f5;font-size:300%";}
      if (accountInfoCR.detailsTableCR[e].holderCRLevel === "Bronze") {boldtext4.style = "color:#f5deb3;font-size:300%";}
      if (accountInfoCR.detailsTableCR[e].holderCRLevel === "Silver") {boldtext4.style = "color:#708090;font-size:300%";}
      if (accountInfoCR.detailsTableCR[e].holderCRLevel === "Gold") {boldtext4.style = "color:#b8860b;font-size:300%";}
      if (accountInfoCR.detailsTableCR[e].holderCRLevel === "Platinum") {boldtext4.style = "color:#2f4f4f;font-size:300%";}
      boldtext4.innerHTML = "&squf; ";
      td4.appendChild(boldtext4);
      

      tr.appendChild(td0); 
      tr.appendChild(td1);
      tr.appendChild(td2);
      tr.appendChild(td3);
      tr.appendChild(td4);
      tbody.appendChild(tr);
    }
    table.appendChild(tbody);
    
    document.getElementById("table-detailsCR").appendChild(table);

    setDetailStatus(1);
    
  }

function hideCRdetails() {
  const figure = document.getElementById("table-detailsCR");
  while (figure.hasChildNodes()) {
    figure.removeChild(figure.firstChild);
  }

  //document.getElementById('link-hideCRTable').id = 'link-showCRTable';
  document.getElementById("link-showCRTable").innerHTML = "More details";
  //document.getElementById("link-showCRTable").onclick = showCRdetails;

  setDetailStatus(0);

}

  async function connectButton() {

    if (loggedIn ===  0) {
      return CRlogin();
    } else if (loggedIn ===  1) {
      hideCRdetails();
      return CRlogout();
    } else {
      return undefined;
    }
  }

  async function claimButton() {

    if (claimStatus ===  0) {
      //setClaimButtonText("Claim");
      //claimButtonText = "Claim";
      return CRTclaim();
    } else if (claimStatus === 1) {
      //setClaimButtonText("Claiming ... please wait !");
      //claimButtonText = "Claiming ... please wait !";
      return undefined;
    } else if (claimStatus === 2) {
      //setClaimButtonText("Claimed successfully !");
      //claimButtonText = "Claimed successfully !";
      return undefined;
    } else if (claimStatus === 3) {
      //setClaimButtonText("Error occured - please try again.");
      //claimButtonText = "Error occured - please try again.";
      return undefined;
    } else {
      return undefined;
    }
  }

  async function detailsLink() {
    if (loggedIn ===  0) {
      return undefined;
    } else if (loggedIn ===  1 && detailStatus === 0) {
      return showCRdetails();
    } else if (loggedIn ===  1 && detailStatus === 1) {
    return hideCRdetails();
    } else {
      return undefined;
    }
  }

  async function addCRTmetamask() {
    const tokenAddress = '0x1cDc9033Dca5FaD8B47137cf9b775a4d1662FCe8';
    const tokenSymbol = 'CRT';
    const tokenDecimals = 18;
    const tokenImage = 'https://api.cryptoralph.io/pics/CRT-300x300.png';
  
    if (window.ethereum) {
      try {
        // Request to switch to the Mumbai test network (Replace with your network details)
        await window.ethereum.request({
          method: 'wallet_switchEthereumChain',
          params: [{ chainId: '0x89' }], // Mumbai Testnet's chainId 0x13881
        });
  
        // After switching network, attempt to add the token
        const wasAdded = await window.ethereum.request({
          method: 'wallet_watchAsset',
          params: {
            type: 'ERC20', // Initially only supports ERC20, but eventually more!
            options: {
              address: tokenAddress,
              symbol: tokenSymbol,
              decimals: tokenDecimals,
              image: tokenImage,
            },
          },
        });
  
        if (wasAdded) {
          console.log('Thanks for your interest!');
        } else {
          console.log('Your loss!');
        }
      } catch (switchError) {
        // Handle errors, e.g., user rejected the request or the network is not added to MetaMask
        console.error(switchError);
      }
    } else {
      console.log('Ethereum object does not exist!');
    }
  }
  



  return (
    <>
      <div id="content" className="site-content">
            <div id="primary" className="content-area">
                <main id="main" className="site-main" role="main">
                <div className="wp-block-group alignfull has-base-background-color has-background has-global-padding is-layout-constrained wp-block-group-is-layout-constrained">
                <div style={{"height":"20px"}} aria-hidden="true" className="wp-block-spacer"></div>
                    <article id="post-237" className="post-237 page type-page status-draft hentry entry">

                        <header className="entry-header alignwide">
                            <h1 className="entry-title">Dashboard (beta 2)</h1>
                        </header>
                        {/* <!-- .entry-header --> */}

                        <div className="entry-content">
                            
                            <div className="wp-container-1 wp-block-buttons" style={{"display":"flex","justifyContent":"flex-end"}}>
                                <div className="wp-block-button" id="btn-connect">
                                    <a id="btn-CRlogin" onClick={connectButton} className="wp-block-button__link has-background has-medium-font-size" style={{"borderRadius":"10px","backgroundColor":"#C9FF00"}}><strong>Connect wallet</strong></a>
                                </div>
                            </div>
                            <div style={{"height":"20px"}} aria-hidden="true" className="wp-block-spacer"></div>
                            <div className="wp-container-3 wp-block-group" style={{"borderRadius":"10px","borderStyle":"solid","paddingTop":"50px","paddingRight":"50px","paddingBottom":"50px","paddingLeft":"50px"}}>
                                <div className="wp-block-group__inner-container">
                                    <p className="has-large-font-size">
                                        <strong>Account info</strong>
                                    </p>

                                    <p className="has-medium-font-size">You have currently <strong id='txt-amountCR'>&#8212;</strong> Nounscription Genesis in your wallet.</p>
                                    <p className="has-medium-font-size">Thereof <strong id="txt-amountZombieCR">&#8212;</strong> with background "ethscript green" and <strong id="txt-amountAlienCR">&#8212;</strong> with background "glitch red".</p>
                                    
                                    <div style={{"height":"20px"}} aria-hidden="true" className="wp-block-spacer"></div>
                                    <hr class="wp-block-separator has-alpha-channel-opacity is-style-wide"/>
                                    <div style={{"height":"20px"}} aria-hidden="true" className="wp-block-spacer"></div>

                                    <p className="has-medium-font-size"><strong>CryptoRalph Token ($CRT)</strong></p>
                                    <p className="has-medium-font-size">Collected <br/><strong id="txt-collectedCRT">&#8212;</strong><strong> $CRT</strong></p>
                                    <p className="has-medium-font-size">Individual ownership of Nounscription Genesis, currently in your "wallet", add up to <strong id="txt-holderDaysCR">&#8212;</strong> days. This is counted since your first "wallet" connection on this page on <strong id="txt-startDate">&#8212;</strong>.</p>
                                    
                                    <p className="has-medium-font-size"><a id="link-showCRTable" onClick={detailsLink} href="javascript: void(0)"></a></p>
                                    <figure className="wp-block-table is-style-tw-border-h-inner" id="table-detailsCR"></figure>

                                    <div style={{"height":"20px"}} aria-hidden="true" className="wp-block-spacer"></div>
                                    <hr class="wp-block-separator has-alpha-channel-opacity is-style-wide"/>
                                    <div style={{"height":"20px"}} aria-hidden="true" className="wp-block-spacer"></div>

                                    <p className="has-medium-font-size"><strong>Claim $CRT</strong><br></br>on the Polygon chain</p>
                                    <p className="has-medium-font-size">Available (transferable to your wallet without gas fees) <br/><strong id="txt-availableCRT">&#8212;</strong><strong> $CRT</strong></p>

                                    <form id="form-claim" style={{"display":"none"}}>

                                        <div className="wp-container-2 wp-block-buttons">
                                            <div className="wp-block-button has-custom-width wp-block-button__width-100">
                                                <input onClick={claimButton} type="button" value={claimButtonText} id="btn-CRTclaim" className="wp-block-button__link has-background" style={{"borderRadius":"10px","backgroundColor":"#2181e2"}}/>
                                            </div>
                                        </div>
                                        <br/>
                                    </form>

                                    <p id="txt-notEnough" style={{"display":"none","backgroundColor":"#ffe2e2"}} className="has-text-align-center has-background"></p>

                                    
                                    <p className="has-medium-font-size">You can claim available $CRT once per day (maximum of 500) to be transfered to your connected wallet. You already transfered <strong id="txt-transferedCRT">&#8212;</strong> $CRT so far.</p>

                                    <p className="has-medium-font-size"><a id="link-showCRTtransferTable" href="javascript: void(0)"></a></p>
                                    <figure className="wp-block-table is-style-tw-border-h-inner" id="table-detailsCRTtransfer"></figure>

                                    <p className="has-medium-font-size" id="txt-addToMetamask" style={{"display":"none"}}>Add $CRT to Metamask: <a id="link-addToMetamask" onClick={addCRTmetamask} href="javascript: void(0)">click here</a></p>
                                    
                                </div>
                            </div>

                            <div style={{"height":"50px"}} aria-hidden="true" className="wp-block-spacer"></div>

                            <p className="has-large-font-size">
                                <strong>How it works</strong>
                            </p>

                            <p className="has-medium-font-size">With connecting your wallet on this page you start to collect 5 $CRT per day for each Nounscription Genesis you have in the same "wallet". Those $CRT are kept in your bucket and will be shown above.
                            </p>
                            <p className="has-medium-font-size">If Nounscription Genesis is kept in the "wallet" it levels up over time from Standard to Bronze to Silver, Gold and Platinum. With a new Level also the daily token collect is increasing: </p>
                            <figure className="wp-block-table is-style-tw-border-h-inner"><table style={{"borderCollapse":"collapse",width:"100%"}}><tbody><tr style={{"borderBottom":"1px solid #dddddd"}}><td style={{"border":"none"}}><strong>Longer than</strong></td><td style={{"border":"none"}}><strong>Level</strong></td><td style={{"border":"none"}}><strong>Collect</strong></td></tr><tr style={{"borderBottom":"1px solid #dddddd"}}><td style={{"border":"none"}}>0 days</td><td style={{"border":"none"}}><strong style={{"color":"#f5f5f5"}}>▪ </strong>Standard</td><td style={{"border":"none"}}>5 $CRT / day</td></tr><tr style={{"borderBottom":"1px solid #dddddd"}}><td style={{"border":"none"}}>30 day</td><td style={{"border":"none"}}><strong style={{"color":"#f5deb3"}}>▪ </strong>Bronze</td><td style={{"border":"none"}}>6 $CRT / day</td></tr><tr style={{"borderBottom":"1px solid #dddddd"}}><td style={{"border":"none"}}>90 days</td><td style={{"border":"none"}}><strong style={{"color":"#708090"}}>▪ </strong>Silver</td><td style={{"border":"none"}}>8 $CRT / day</td></tr><tr style={{"borderBottom":"1px solid #dddddd"}}><td style={{"border":"none"}}>180 days</td><td style={{"border":"none"}}><strong style={{"color":"#b8860b"}}>▪ </strong>Gold</td><td style={{"border":"none"}}>11 $CRT / day</td></tr><tr style={{"borderBottom":"1px solid #dddddd"}}><td style={{"border":"none"}}>360 days</td><td style={{"border":"none"}}><strong style={{"color":"#2f4f4f"}}>▪ </strong>Platinum</td><td style={{"border":"none"}}>15 $CRT / day</td></tr></tbody></table></figure>
                            <div style={{"height":"10px"}} aria-hidden="true" className="wp-block-spacer"></div>
                            <p className="has-medium-font-size">To see your transferred $CRT in your MetaMask wallet, you need to change the network to Polygon and add the token. You can simply use the link in the "Claim $CRT" section above to do both.
                            </p>
                            <p className="has-medium-font-size">There will be airdrops of $CRT from time to time targeting specific traits only. Sometimes we might give a hint here, on Twitter or in Discord ;-)
                            </p>
                            <p className="has-medium-font-size">You can also transfer your $CRT to your Polygon wallet, which will enable you to use them in the Store or for other purposes.
                            </p>
                            <p className="has-medium-font-size">$CRT will seriously increase the experience of owning Nounscriptions. <br/>But it is not an investment and has NO monetary value. $CRT is the utility token of the Nounscriptions ecosystem.
                            </p>
                            <div style={{"height":"20px"}} aria-hidden="true" className="wp-block-spacer"></div>

                        </div>

                        
                        {/* <!-- .entry-content --> */}

                    </article>
                    {/* <!-- #post-237 --> */}

                </div>

                </main>
                {/* <!-- #main --> */}

            </div>
            {/* <!-- #primary --> */}
        </div>
        {/* <!-- #content --> */}



    </>
  );
}

export default App;
